import Vue from 'vue'

Vue.component('count-unread-messages', require('./ContMessage').default);
Vue.component('count-unread-student-messages', require('./ContStudentSidebarMessage').default);
Vue.component('count-unread-teacher-messages', require('./ContTeacherMessage').default);
Vue.component('teacher-chat-wrapper-component', require('./TeacherChatWrapperComponent').default);
Vue.component('student-chat-wrapper-component', require('./StudentChatWrapperComponent').default);
Vue.component('student-chat-wrapper-component-footer', require('./StudentChatWrapperComponentFooter').default);
Vue.component('teacher-schedule', require('./TeacherSchedule').default);
Vue.component('teacher-reports-component', require('./TeacherReportsComponent').default);
Vue.component('teacher-questionnaire-component', require('./Teacher/Questionnaire/QuestionnaireComponent').default);
Vue.component('teacher-reports-visiting-missing-students-component', require('./TeacherReportsVisitingMissingStudentsComponent').default);
Vue.component('teacher-reports-students-searning-sap-component', require('./TeacherReportsStudentsLearningGapComponent').default);
Vue.component('teacher-reports-average-score-component', require('./TeacherReportsAverageScoreComponent').default);
Vue.component('student-practice', require('./Student/StudentPractice').default);
Vue.component('student-schedule', require('./StudentSchedule').default);
Vue.component('tutor-practice', require('./Tutor/TutorPractice').default);
Vue.component('student-practice-add-period-modal', require('./Student/StudentPracticeAddPeriodModal').default);
Vue.component('student-lesson', require('./Student/StudentLesson').default);
Vue.component('deadline-timer', require('./DeadlineTimer').default);
Vue.component('vue-dynamic-component', require('./Common/VueDynamicComponent.vue').default);
